module.exports = __webpack_public_path__ + "img/graph-dummy-md.a68379a1.svg";